// entry point for commonjs systems
module.exports = require('./src/hudl');
